import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import Modal from '@mui/material/Modal';
import Fab from '@mui/material/Fab';
import Clear from '@mui/icons-material/Clear';
import { stringIsNullOrEmpty } from '../../utils/strings';
import InfoCircleIcon from '../icon/InfoCircleIcon';
import TickCircleIcon from '../icon/TickCircleIcon';
import ExclamationCircleIcon from '../icon/ExclamationCircleIcon';
import ExclamationTriangleIcon from '../icon/ExclamationTriangleIcon';
import Button from '../form/Button';
import Inline from '../layout/Inline';

class AlertModal extends Component {
    render() {
        const { open, onClose, variant } = this.props;

        return (
            <Modal
                open={open}
                aria-labelledby="alert-modal-title"
                aria-describedby="alert-modal-description"
                disableEscapeKeyDown={false}
            >
                <div className={`modal modal--alert modal--alert--${variant || 'primary'}`}>
                    <Fab color="primary" aria-label="Close" className="fab close" onClick={() => onClose()}>
                        <Clear />
                    </Fab>
                    <div className="paper">
                        {this.renderContent()}
                    </div>
                </div>
            </Modal>
        );
    }

    renderContent() {
        const {
            children,
            variant,
            primaryAction,
            onClickPrimaryAction,
            secondaryAction,
            onClickSecondaryAction,
            onClose
        } = this.props;

        let icon;
        let buttonVariant;
        if (variant === 'save') {
            icon = <TickCircleIcon />;
            buttonVariant = 'confirmation';
        } else if (variant === 'warning') {
            icon = <ExclamationTriangleIcon />;
            buttonVariant = 'urgent';
        } else if (variant === 'error') {
            icon = <ExclamationCircleIcon />;
            buttonVariant = 'decline';
        } else {
            icon = <InfoCircleIcon />;
            buttonVariant = 'primary';
        }

        return (
            <div className="alert-content">
                <div className="icon">{icon}</div>
                <div className="content">{children}</div>
                <Inline>
                    {!stringIsNullOrEmpty(secondaryAction) && (
                        <Button variant="secondary" onClick={onClickSecondaryAction}>
                            {secondaryAction}
                        </Button>
                    )}
                    {!stringIsNullOrEmpty(primaryAction) && (
                        <Button variant={buttonVariant} onClick={onClickPrimaryAction}>
                            {primaryAction}
                        </Button>
                    )}
                    {stringIsNullOrEmpty(primaryAction) && stringIsNullOrEmpty(secondaryAction) && (
                        <Button variant="modal-action modal-action--cancel" onClick={onClose}>
                            Close
                        </Button>
                    )}
                </Inline>
            </div>
        );
    }
}

export default withStyles({})(AlertModal);
